import React, { Component } from 'react'

export default class DeviceQuantityBoard extends Component {
    render() {
        return (
            <div className="device-quantity">
                对应指标
            </div>
        )
    }
}
